import { UserModel } from '../../../../../models/user';

export default function groupsTemplate(data: UserModel) {
  if (data.groupsDetail) {
    return data.groupsDetail.map(({ name }) => name).join(', ');
  }
  return '';
}
